<app-simple-modal [title]="'Crear Usuario'" [max]="30" (close)="close.emit($event)">
	<div fields>
		<div class="form-group">
			<label for="name" class="form-label">Nombre
				<i class="fa fa-asterisk text-danger"></i>
			</label>
			<input type="text" [(ngModel)]="newUser.userName" id="name" placeholder="Ingresa el nombre del usuario" name="name"
				class="form-control">
		</div>
		<div class="form-group">
			<label for="email" class="form-label">Email
				<i class="fa fa-asterisk text-danger"></i>
			</label>
			<input type="text" [(ngModel)]="newUser.email" id="email" name="email"
				placeholder="Ingresa el correo de la forma usuario@servidor.com" class="form-control">
			<span class="form-text" *ngIf="errorMessageEmail!=''">{{errorMessageEmail}}</span>
		</div>
	</div>
	<div buttons>
		<app-loading-button [object]="buttonSave" (clicked)="createUser()"></app-loading-button>
	</div>
</app-simple-modal>